function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_612",
  "data-name": "Grupo 612",
  transform: "translate(0 1.83)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_610",
  "data-name": "Grupo 610"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_902",
  "data-name": "Caminho 902",
  d: "M363.392,98.407H350.041a1.549,1.549,0,0,1-1.45-1.628V85.865a1.548,1.548,0,0,1,1.45-1.628h13.352a1.548,1.548,0,0,1,1.45,1.628V96.779A1.549,1.549,0,0,1,363.392,98.407ZM350.041,85.088a.738.738,0,0,0-.692.777V96.779a.738.738,0,0,0,.692.776h13.352a.738.738,0,0,0,.692-.776V85.865a.738.738,0,0,0-.692-.777Z",
  transform: "translate(-348.591 -84.237)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_611",
  "data-name": "Grupo 611",
  transform: "translate(0.425 4.081)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1417",
  "data-name": "Ret\\xE2ngulo 1417",
  width: 15.4,
  height: 0.851
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_615",
  "data-name": "Grupo 615",
  transform: "translate(2.003)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_613",
  "data-name": "Grupo 613"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1418",
  "data-name": "Ret\\xE2ngulo 1418",
  width: 1.719,
  height: 4.082,
  rx: 0.859
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_614",
  "data-name": "Grupo 614",
  transform: "translate(10.526)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1419",
  "data-name": "Ret\\xE2ngulo 1419",
  width: 1.719,
  height: 4.082,
  rx: 0.859
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_624",
  "data-name": "Grupo 624",
  transform: "translate(2.595 8.947)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_616",
  "data-name": "Grupo 616"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1420",
  "data-name": "Ret\\xE2ngulo 1420",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_617",
  "data-name": "Grupo 617",
  transform: "translate(3.795)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1421",
  "data-name": "Ret\\xE2ngulo 1421",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_618",
  "data-name": "Grupo 618",
  transform: "translate(7.59)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1422",
  "data-name": "Ret\\xE2ngulo 1422",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_619",
  "data-name": "Grupo 619",
  transform: "translate(11.385)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1423",
  "data-name": "Ret\\xE2ngulo 1423",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_620",
  "data-name": "Grupo 620",
  transform: "translate(0 2.578)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1424",
  "data-name": "Ret\\xE2ngulo 1424",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_621",
  "data-name": "Grupo 621",
  transform: "translate(3.795 2.578)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1425",
  "data-name": "Ret\\xE2ngulo 1425",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_622",
  "data-name": "Grupo 622",
  transform: "translate(7.59 2.578)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1426",
  "data-name": "Ret\\xE2ngulo 1426",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_623",
  "data-name": "Grupo 623",
  transform: "translate(11.385 2.578)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1427",
  "data-name": "Ret\\xE2ngulo 1427",
  width: 1.485,
  height: 1.485,
  rx: 0.743
})));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_625",
    "data-name": "Grupo 625",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.251,
    height: 16,
    viewBox: "0 0 16.251 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d6d15a58.svg";
export { ForwardRef as ReactComponent };